export const TICKETS_EVENTS = {
  TOGGLE_ORDER_FORM: 'toggleOrderForm',
  INIT_TICKETS: 'initTickets',
  SET_PRICES: 'setPrices',
  RENDER_TICKETS: 'renderTickets',
  CHECK_ERROR: 'checkError',
  CHANGE: 'change',
  ADD: 'add',
  REMOVE: 'remove',
  SHOW_TICKETS_COUNT_MODAL: 'showTicketsCountModal',
  SET_NEW_SELECTED_TICKETS: 'setNewSelectedTickets',
  UPDATE_COUNT: 'updateCount',
};
